import reducer, {
    fetchPrograms,
    programUpsell,
    hypertensionRegistration,
    clientProfile,
} from './programsSlice';

export {fetchPrograms, programUpsell, hypertensionRegistration, clientProfile};
export default reducer;
